export default {
    title: "评分系统",
    footer: ["面试管理专家", "大型面试的好帮手", "版本{version}"],
    footerBoc: ["中国银行面试评分系统"],
    placeholder: {
        email: "邮箱",
        password: "密码",
    },
    login: "登录",
    detectionTips: "如有视频日程，请先进行",
    detectionButton: "设备检测",
    failMsg: "用户名或密码错误，请重试",
};
